import React from 'react';

import {getSharedSmartChipProps, SharedSmartChipProps} from 'ui-library/chips/ChipUtil';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import SmartChip from './SmartChip';
import useSmartChipQuery, {SmartChipType} from './useSmartChipQuery';

export default function StorableSchemaChip(
  props: SharedSmartChipProps<SmartChipType.STORABLE_SCHEMA>
): JSX.Element {
  const sharedSmartChipProps = getSharedSmartChipProps(props);
  const {id, onClick} = sharedSmartChipProps;

  const {
    item: storableSchema,
    handleClickLink,
    isInaccessible,
  } = useSmartChipQuery<SmartChipType.STORABLE_SCHEMA>({
    id,
    onClick,
  });

  return (
    <SmartChip
      {...sharedSmartChipProps}
      icon={(storableSchema?.iconId as BenchlingIconName) ?? null}
      isInaccessible={isInaccessible}
      item={storableSchema}
      onClick={handleClickLink}
      url={null}
    />
  );
}
